// extracted by mini-css-extract-plugin
export default {"container":"assessmentInfoCard_container__1tW7f","text":"assessmentInfoCard_text__J1iv0"};